<div class="flex-row">
  <div class="flex--row flex__child">
    <div class="selector-with-warning plant-date-control-with-warning">
      <mat-form-field
        [matTooltip]="plantDateDisabledReasonKey() | translate"
        [matTooltipDisabled]="!plantDateDisabledReasonKey()"
        class="flex__child--auto selector"
        [ngClass]="{
          'date-picker-field-disabled': isPlantDateInputDisabled(),
          'plant-date-field--warning': plantDateWarningCodes().length > 0,
        }"
        subscriptSizing="dynamic"
      >
        <mat-label class="date-picker-lable">{{ resolvedPlantDateConfig().labelKey | translate }}</mat-label>
        <input
          id="shared-plant-date-input"
          [attr.aria-label]="resolvedPlantDateConfig().labelKey | translate"
          class="date-picker-input"
          matInput
          [matDatepicker]="plantingDatePicker"
          [formControl]="plantingDateFormControl"
          [min]="plantDateMin()"
          [max]="plantDateMax()"
        />
        <mat-datepicker-toggle matIconSuffix [for]="plantingDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #plantingDatePicker></mat-datepicker>
      </mat-form-field>
      @if (plantDateWarningCodes().length > 0) {
        <app-plant-date-warning [warningCodes]="plantDateWarningCodes()"></app-plant-date-warning>
      }
    </div>

    @if (showEmergenceDate()) {
      <mat-form-field
        [matTooltip]="emergenceDisabledTooltipText() | translate"
        [matTooltipDisabled]="!emergenceDisabledTooltipText()"
        class="date-picker flex__child--auto selector"
        [ngClass]="isEmergenceDateReadonlyAction() ? 'readonly-date-field' : ''"
        (mousedown)="onReadonlyDateMouseDown($event, 'emergence')"
        (click)="onEmergenceDateInteraction($event, emergenceDatePicker)"
        (keydown.enter)="onEmergenceDateInteraction($event, emergenceDatePicker)"
        subscriptSizing="dynamic"
      >
        <mat-label class="date-picker-lable">{{ resolvedEmergenceDateConfig().labelKey | translate }}</mat-label>
        <input
          id="shared-emergence-date-input"
          [attr.aria-label]="resolvedEmergenceDateConfig().labelKey | translate"
          class="date-picker-input"
          [class.readonly-date-input]="isEmergenceDateReadonlyAction()"
          matInput
          [matDatepicker]="emergenceDatePicker"
          [formControl]="emergenceDateFormControl"
          [readonly]="isEmergenceDateReadonlyAction()"
          [min]="emergenceDateMin"
          [max]="emergenceDateMax"
        />
        @if (isEmergenceDateReadonlyAction()) {
          <span
            matSuffix
            [matTooltip]="emergenceReadonlyActionReasonKey() | translate"
            [matTooltipDisabled]="!isReadonlyActionDisabled('emergence')"
          >
            <button
              type="button"
              mat-icon-button
              [disabled]="isReadonlyActionDisabled('emergence')"
              (mousedown)="$event.stopPropagation()"
              (click)="onReadonlyDateActionClicked($event, 'emergence')"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </span>
        } @else {
          <mat-datepicker-toggle matSuffix [for]="emergenceDatePicker"></mat-datepicker-toggle>
        }
        <mat-datepicker #emergenceDatePicker></mat-datepicker>
      </mat-form-field>
    }

    @if (showHarvestDate()) {
      <mat-form-field
        [matTooltip]="harvestDisabledTooltipText() | translate"
        [matTooltipDisabled]="!harvestDisabledTooltipText()"
        class="date-picker flex__child--auto selector"
        [ngClass]="isHarvestDateReadonlyAction() ? 'readonly-date-field' : ''"
        (mousedown)="onReadonlyDateMouseDown($event, 'harvest')"
        (click)="onHarvestDateInteraction($event, harvestDatePicker)"
        (keydown.enter)="onHarvestDateInteraction($event, harvestDatePicker)"
        subscriptSizing="dynamic"
      >
        <mat-label class="date-picker-lable">{{ resolvedHarvestDateConfig().labelKey | translate }}</mat-label>
        <input
          id="shared-harvest-date-input"
          [attr.aria-label]="resolvedHarvestDateConfig().labelKey | translate"
          class="date-picker-input"
          [class.readonly-date-input]="isHarvestDateReadonlyAction()"
          matInput
          [matDatepicker]="harvestDatePicker"
          [formControl]="harvestDateFormControl"
          [readonly]="isHarvestDateReadonlyAction()"
          [min]="harvestDateMin"
          [max]="harvestDateMax"
        />
        @if (isHarvestDateReadonlyAction()) {
          <span
            matSuffix
            [matTooltip]="harvestReadonlyActionReasonKey() | translate"
            [matTooltipDisabled]="!isReadonlyActionDisabled('harvest')"
          >
            <button
              type="button"
              mat-icon-button
              [disabled]="isReadonlyActionDisabled('harvest')"
              (mousedown)="$event.stopPropagation()"
              (click)="onReadonlyDateActionClicked($event, 'harvest')"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </span>
        } @else {
          <mat-datepicker-toggle matSuffix [for]="harvestDatePicker"></mat-datepicker-toggle>
        }
        <mat-datepicker #harvestDatePicker></mat-datepicker>
      </mat-form-field>
    }
  </div>
</div>
